import { render, staticRenderFns } from "./WaintingUsers.vue?vue&type=template&id=65e5b487&scoped=true&"
import script from "./WaintingUsers.vue?vue&type=script&lang=js&"
export * from "./WaintingUsers.vue?vue&type=script&lang=js&"
import style0 from "./WaintingUsers.vue?vue&type=style&index=0&id=65e5b487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5b487",
  null
  
)

export default component.exports